export default "__VITE_ASSET__D7fvUI3H__"